export enum TransferStatus {
  Queued = "queued",
  Processing = "processing",
  Success = "success",
  Failed = "fail",
}

export enum TargetType {
  Sergio = "sergio",
  VolumeColor = "volume_color",
}

export interface Transfer {
  _id: string;
  selfieId: string;
  target_type: TargetType;
  status: TransferStatus;
  hairstyleId: string;
  state: string;
  image_url: string;
  aligned_selfie_url: string;
}

export interface VolumeColorTransfer extends Transfer {
  urls?: {
    image_url: string;
  }[];
}

export interface VolumeColorTransferNormalized {
  color: string;
  image_url: string;
  volume: string;
  state: string;
}
